export default {
  app: {
    privacy: {
      policy: 'gizlilik politikası',
      expansive: 'Expansive uygulamasını kullanarak Expansive {action} kabul etmiş olursunuz',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Oturum süresi doldu',
    sessionExpiredDescription:
      'Oturumunuzun süresi doldu. Uygulamayı kullanmaya devam etmek için lütfen tekrar giriş yapın.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Dil seçin',
      chooseLanguageDescription:
        'Uygulama için tercih ettiğiniz dili seçin. Bu, arayüzün ve içeriğin dilini değiştirecektir.',
    },
    userSelection: {
      cancel: 'İptal',
      createNewUser: 'İsimleri listede yok',
      newUser: 'Yeni kullanıcı',
      selectAnExistingUser: 'Mevcut bir kullanıcıyı seçin',
      selectUserHint: 'Devam etmek için mevcut bir kullanıcı seçin veya yeni bir tane oluşturun.',
      startTypingToSearch: 'Yazmaya başlayın...',
    },
    verification: {
      codeVerification: {
        continue: 'Devam et',
        header: 'Site erişim kodunu girin',
        invalidCode: 'Geçersiz kod, lütfen tekrar deneyin.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Konum doğrulaması olmadan devam et',
        enterSiteAccessCode: 'Site erişim kodunu girin',
        locationNotEnabledOrAvailable: 'Bunu neden görüyorum?',
        notAvailable: {
          description: 'GPS konumu bu cihazda desteklenmiyor.',
          header: 'Konum desteklenmiyor',
        },
        notEnabled: {
          description: 'Konum servisleri etkin değil veya izin verilmemiş.',
          header: 'Konum etkin değil',
        },
        notVerified: {
          description: 'GPS, sitede olmadığınızı gösteriyor.',
          header: 'Konum doğrulanmadı',
        },
        tryAgain: 'Tekrar deneyin',
        unavailable: {
          description: 'GPS konumunuzu doğrulayamadık.',
          header: 'Konum kullanılamıyor',
        },
        unknown: {
          description: 'Konumunuzu belirleyemiyoruz.',
          header: 'Konum bilinmiyor',
        },
        verified: {
          description: 'GPS, sitede olduğunuzu gösteriyor.',
          header: 'Konum doğrulandı',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Varlık bulunamadı',
        emptyDescription: 'Bu iş emriyle ilişkili varlık yok.',
        warrantyParts: 'Parça garantisi bitişi',
        serialNumber: 'Seri numarası',
        none: '<yok>',
      },
      updates: {
        emptyTitle: 'Güncelleme bulunamadı',
        emptyDescription: 'Bu iş emri için güncelleme yok.',
        unknownUser: 'Bilinmeyen kullanıcı',
        none: 'Yok',
        addComment: {
          buttonLabel: 'Yorum ekle',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Tehlikeler',
          no: 'Hayır',
          yes: 'Evet',
        },
      },
    },
    attachmentsList: {
      attachments: 'Ekler',
      documents: 'Belgeler',
      siteDocuments: 'Site Belgeleri',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Tehlikeler',
        induction: 'Oryantasyon',
        safeToProceed: 'Devam etmek güvenli',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Bitiş tarihi',
        activeSessions: 'Aktif oturumlar',
        activeSessionsDescription:
          'Aşağıdaki iş emirlerine zaten giriş yaptınız. Yeni bir iş emrine giriş yapmadan önce bu iş emirlerinden çıkış yapmalısınız.',
        resumeSession: 'Devam et',
        startTime: 'Başlangıç zamanı',
        unexpectedErrorTitle: 'Beklenmeyen hata',
        unexpectedErrorMessage:
          'Oturumlarınızı oluştururken beklenmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyin.',
        engineerNotFound: 'Mühendis bulunamadı',
        engineerNotFoundDescription:
          'Giriş yapmaya çalıştığınız mühendis sistemde bulunamadı. Lütfen yöneticinizle iletişime geçin.',
      },
      verification: {
        code: {
          description:
            'Giriş yapmak için lütfen site yöneticisinden veya yetkili kişiden 4 haneli kodu alın.',
        },
        geo: {
          continue: 'Devam et',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Ziyaretinizi tamamlamak için site yöneticisinden veya yetkili kişiden erişim kodunu alınız.',
            checkOut: 'Çıkış yap',
            completeBeforeLeaving: 'Ayrılmadan önce lütfen aşağıdaki formu doldurun.',
            continue: 'Devam et',
            noResolutionSelected: 'Devam etmeden önce lütfen bir çözüm seçin.',
            quoteRequired: {
              hint: 'Ziyaret tamamlandı, teklif verilecek',
              label: 'Teklif gerekli',
            },
            returnVisitRequired: {
              hint: 'Tamamlamak için tekrar geleceğiz',
              label: 'Tekrar ziyaret gerekli',
            },
            serviceCompleted: {
              hint: 'Başka işlem gerekmiyor',
              label: 'Hizmet tamamlandı',
            },
            uploadCheckout: 'Dosya, fotoğraf veya video yükle',
            visitNotes: 'Ziyaret notları',
            workOrderResolution: 'İş emri çözümü',
            enterNotes: 'Herhangi bir notu buraya girin...',
            errors: {
              timedOut: 'Zaman aşımı, 30 saniye aşıldı. Lütfen tekrar deneyin.',
              closingSession: 'Oturum kapatılırken hata oluştu',
            },
          },
          success: {
            description:
              'Ziyaretiniz için teşekkürler {site}. | {site} için 1 açık iş emri kaldı. | {site} için {count} açık iş emri kaldı.',
            endVisit: 'Ziyareti bitir',
            header: 'Başarıyla çıkış yaptınız',
            viewWorkOrders: 'Başka bir iş emrine giriş yap',
          },
          verification: {
            code: {
              description:
                'Çıkış yapmak için lütfen site yöneticisinden veya yetkili kişiden 4 haneli kodu alın.',
              continue: 'Devam et',
            },
            geo: {
              checkOut: 'Çıkış yap',
              continue: 'Devam et',
            },
          },
        },
        detail: {
          assets: 'Varlıklar',
          call: 'Ara',
          checkOut: 'Çıkış yap',
          closed: 'Kapalı',
          details: 'Detaylar',
          dueBy: 'Bitiş tarihi',
          manageEngineers: 'Mühendisleri yönet',
          notAvailable: 'Mevcut değil',
          pointOfContact: 'İrtibat noktası',
          siteAccessTimes: 'Site erişim saatleri',
          siteAccessInstructions: 'Erişim talimatları',
          siteAddress: 'Site adresi',
          siteNotes: 'Site notları',
          siteTelephone: 'Site telefonu',
          siteLocation: 'Site konumu',
          updates: 'Güncellemeler',
          more: 'Daha fazla',
          mismatchErrorTitle: 'İş emri hatası',
          mismatchErrorMessage:
            'Erişmeye çalıştığınız iş emri, şu anda giriş yaptığınız iş emriyle eşleşmiyor. Lütfen iş emrinizi kontrol edin ve tekrar deneyin.',
          siteDocuments: 'Site belgeleri',
          validFrom: 'Geçerlilik başlangıcı',
          validUntil: 'Geçerlilik bitişi',
          documentName: 'Belge adı',
          documentType: 'Belge türü',
          attachments: 'İş emri dosyaları',
          download: 'İndir',
          workDetails: 'İş detayları',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Yardımcı mühendis ekle',
            assistantEngineers: 'Yardımcı mühendisler',
            description: 'Güvenlik nedeniyle, lütfen sahadaki her mühendisin adını belirtin.',
            editMainEngineer: 'Ana mühendisi düzenle',
            errors: {
              creatingEngineer: 'Mühendis oluşturulurken hata oluştu',
              creatingSession: 'Oturum oluşturulurken hata oluştu',
            },
            header: 'Sahadaki mühendisler',
            mainEngineer: 'Ana mühendis',
            newAssistantEngineer: 'Tam adını girin',
            next: 'İleri',
            removeEngineer: 'Mühendisi kaldır',
            selectExistingAssistantEngineer: 'Adını yazmaya başlayın',
          },
          index: {
            description: 'Güvenlik nedeniyle, lütfen sahadaki her mühendisin adını belirtin.',
            errorCreatingEngineer: 'Mühendis oluşturulurken hata oluştu, lütfen tekrar deneyin.',
            header: 'Sahadaki mühendisler',
            hintMainEngineer: 'Ana mühendisin tam adını girin',
            newMainEngineer: 'Yeni ana mühendis',
            next: 'İleri',
            selectExistingMainEngineer: 'Mevcut bir ana mühendis seçin',
            yes: 'Evet',
            no: 'Hayır',
            mainEngineerLabel: 'Ana mühendis misiniz?',
          },
        },
        index: {
          callUsOn: '{phoneNumber} numarasından bizi arayın',
          description: 'Aradığınızı bulamıyor musunuz?',
          dueBy: 'Bitiş tarihi',
          header: 'İş emri seçin',
          notAvailable: 'Mevcut değil',
          searchWorkOrders: 'İş emirlerinde ara...',
        },
        manageEngineers: {
          manageEngineers: 'Mühendisleri yönet',
          notWorking: 'Aktif olmayan çalışanlar',
          pause: 'Duraklat',
          resume: 'Devam et',
          workingNow: 'Aktif çalışanlar',
          startTime: 'Başlangıç zamanı',
          endTime: 'Bitiş zamanı',
          duration: 'Süre',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Geri bildirim',
            feedbackDescription:
              'Hizmetlerimizi geliştirmemize yardımcı olmak için lütfen iş emri hakkında geri bildirimde bulunun.',
            feedbackLabel: 'Geri bildirim',
            filesLabel: 'Ekler',
            submissionLabel: 'Geri bildirimi gönder',
          },
          hazards: {
            back: 'Geri dön',
            hazards: 'Tehlikeler',
            next: 'İleri',
            no: 'Hayır',
            noTasksForHazard: 'Bu tehlike için tamamlanacak görev yok.',
            yes: 'Evet',
          },
          induction: {
            continue: 'Devam et',
            induction: 'Oryantasyon',
          },
          index: {
            checkIn: 'Giriş yap',
            description: 'Seçilen iş için lütfen aşağıdaki risk değerlendirmesini tamamlayın.',
            fail: 'İşe başlama kontrolleri işlenirken hata oluştu.',
            haltMessage:
              'Potansiyel riskler tespit edildi. Lütfen işi durdurun, güvenlik yönergelerini gözden geçirin ve daha fazla talimat için amirinize başvurun.',
            header: 'İşe başlama kontrolleri',
            endVisit: 'Ziyareti bitir',
            leaveFeedback: 'Geri bildirim bırak',
          },
          safeToProceed: {
            continue: 'Devam et',
            safeToProceed: 'Devam etmek güvenli',
          },
        },
      },
    },
    index: {
      title: 'Hoş geldiniz',
      description: 'Başlamak için konumunuzdaki QR kodunu tarayın.',
    },
    login: {
      errorTitle: 'Beklenmeyen hata',
      errorMessage: 'Beklenmeyen bir hata oluştu. Lütfen QR kodunu tekrar taramayı deneyin.',
    },
    unauthenticated: {
      welcome: {
        title: '{site} sitesine hoş geldiniz',
        description:
          'Herhangi bir iş emrini görüntülemeden önce, bilgilerinizi doğrulamamız gerekiyor. Devam etmek için aşağıdaki butona tıklayın.',
        next: 'Devam et',
      },
      index: {
        errorTitle: 'Beklenmeyen hata',
        errorMessage: 'Beklenmeyen bir hata oluştu. Lütfen QR kodunu tekrar taramayı deneyin.',
      },
      contractor: {
        title: 'Kimin için çalışıyorsunuz?',
        contractor: 'Yüklenici',
        contractorLabel: 'Şirket adınızı yazmaya başlayın',
        contractorHint: 'Sonuçları görmek için en az 3 karakter girmelisiniz',
        defaultSelectPlaceholder: '--Lütfen seçin--',
        next: 'İleri',
      },
      user: {
        title: 'Siz kimsiniz?',
        cancel: 'İptal',
        createNewUserLabel: 'Adım listede yok',
        existingUserLabel: 'Adınızı yazmaya başlayın',
        existingUserHint: 'Sonuçları görmek için en az 3 karakter girmelisiniz',
        newUserLabel: 'Tam adınızı girin',
        next: 'İleri',
        user: 'Kullanıcı',
      },
      verification: {
        methods: {
          add: {
            add: 'Doğrulama yöntemi ekle',
            defaultSelectPlaceholder: '--Lütfen seçin--',
            emailLabel: 'E-posta',
            existingMethodWarning:
              'Bu doğrulama yöntemi için zaten onay bekleyen bir isteğiniz var. Yeni bir tane eklemek mevcut isteği geçersiz kılacaktır.',
            method: 'Yöntem',
            methodLabel: 'Yöntem',
            mobileCountryHint: 'Lütfen ülke kodunuzu seçin',
            mobileCountryLabel: 'Mobil ülke kodu',
            mobileHint: 'Lütfen cep telefonu numaranızı girin',
            mobileLabel: 'Mobil',
            title: 'Doğrulama yöntemi ekle',
          },
          confirm: {
            confirm: 'Onayla',
            description: 'Devam etmek için lütfen doğrulama yöntemini onaylayın.',
            label: 'Kodunuzu girin',
            resend: 'Tekrar gönder',
            resendPrompt: 'Kod gelmedi mi?',
            title: 'Doğrulama Yöntemini Onayla',
          },
          confirmed: {
            description:
              'Bu doğrulama yöntemi yöneticiniz tarafından onaylandığında bilgilendirileceksiniz ve ardından kimliğinizi doğrulamak için kullanmaya başlayabilirsiniz.',
            forceApproval: 'Onaylanana kadar iş emirlerine erişemezsiniz.',
            nonForceApproval: 'Bu arada, iş emirlerine sınırlı erişimle devam edebilirsiniz.',
            nonForceApprovalButtonLabel: 'Sınırlı erişimle devam et',
            title: 'Onay bekleniyor',
          },
          addNew: 'Yeni doğrulama yöntemi ekle',
          description: 'İş emrine tam erişim sağlamak için kimliğinizi doğrulamamız gerekiyor.',
          email: 'E-posta',
          hint: 'Seçtiğiniz doğrulama yöntemine bir bağlantı göndereceğiz. Bu bağlantı size iş emrine tam erişim sağlar. Mevcut doğrulama yöntemlerini değiştirmek için lütfen yöneticinizle iletişime geçin.',
          label: 'Bir doğrulama yöntemi seçin',
          next: 'İleri',
          pendingHint: 'Yönetici onayı bekleniyor',
          sms: 'SMS',
          title: 'Doğrulama',
        },
        optional: {
          hint: 'Kullanıcı bilgilerinizi doğrulamanız iş emrine tam erişim sağlar',
          label: 'Kullanıcı bilgilerinizi doğrulamak ister misiniz?',
          next: 'İleri',
          no: 'Hayır',
          noHint:
            'Kullanıcı bilgilerimi doğrulamak istemiyorum ve iş emrine sınırlı erişimle devam edeceğim',
          title: 'Doğrulama',
          yes: 'Evet',
          yesHint: 'Kullanıcı bilgilerimi doğrulamak ve iş emrine tam erişim almak istiyorum',
        },
        sent: {
          description:
            '{identifier} adresine bir giriş bağlantısı gönderildi. Lütfen girişinizi tamamlamak için bağlantıya tıklayın.',
          title: 'Giriş bağlantısı gönderildi',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Dün',
      today: 'Bugün',
      days: {
        monday: 'Pazartesi',
        tuesday: 'Salı',
        wednesday: 'Çarşamba',
        thursday: 'Perşembe',
        friday: 'Cuma',
        saturday: 'Cumartesi',
        sunday: 'Pazar',
      },
      months: {
        january: 'Ocak',
        february: 'Şubat',
        march: 'Mart',
        april: 'Nisan',
        may: 'Mayıs',
        june: 'Haziran',
        july: 'Temmuz',
        august: 'Ağustos',
        september: 'Eylül',
        october: 'Ekim',
        november: 'Kasım',
        december: 'Aralık',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Bir şeyler ters gitti',
      message: 'Lütfen QR kodunu tekrar taramayı deneyin.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Bilinmeyen kullanıcı',
      },
      none: 'Yok',
      types: {
        stateTransition: 'Durum değişti',
        contractorAssigned: 'Yüklenici atandı',
        engineerAssigned: 'Mühendis atandı',
        serviceAssigned: 'Hizmet atandı',
        priorityChanged: 'Öncelik değişti',
        actionableDateChanged: 'İşlem tarihi değişti',
        dueDateChanged: 'Bitiş tarihi değişti',
        etaDateChanged: 'Tahmini varış tarihi değişti',
        spendLimitApproved: 'Harcama limiti onaylandı',
        spendLimitCancelled: 'Harcama limiti isteği iptal edildi',
        spendLimitRejected: 'Harcama limiti reddedildi',
        spendLimitRequested: 'Harcama limiti istendi',
        jobSheetUploaded: 'İş formu yüklendi',
        slaAlertSent: 'Katılım süresi SLA uyarısı aşıldı',
        issuedWorkPermit: 'Çalışma izni verildi',
        requestForServiceSent: 'Hizmet talebi gönderildi',
        comment: 'Yorum eklendi',
        unknown: 'Bilinmeyen olay',
      },
      labels: {
        actionableDate: 'İşlem tarihi',
        comment: 'Yorum',
        file: 'Dosya',
        contractor: 'Yüklenici',
        dueDate: 'Bitiş tarihi',
        etaDate: 'Tahmini varış tarihi',
        engineer: 'Mühendis',
        priority: 'Öncelik',
        requestForService: 'Hizmet talebi',
        service: 'Hizmet',
        spendLimit: 'Harcama limiti',
        status: 'Durum',
        workPermit: 'Çalışma izni',
      },
    },
  },
}
